function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(param, param1) {
    var font = param.font, readingDirection = param1.readingDirection;
    return {
        container: _objectSpread({}, readingDirection, {
            paddingTop: 24,
            paddingBottom: 24,
            paddingLeft: 40,
            paddingRight: 40,
            maxHeight: '100vh'
        }),
        actionContainer: {
            flexShrink: 0
        },
        wrapper: _objectSpread({}, readingDirection, {
            height: '100%',
            paddingTop: '2rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            fontFamily: font.base.family,
            fontWeight: font.base.weight.regular
        }),
        image: {
            width: '70%',
            maxWidth: 375
        },
        illustrationContainer: {
            textAlign: 'center',
            margin: '0 auto',
            maxWidth: '100%'
        },
        header: {
            default: _objectSpread({}, readingDirection, {
                fontSize: font.base.size.h2,
                display: 'block',
                textAlign: 'center',
                color: font.color.base,
                fontFamily: font.base.family,
                fontWeight: font.base.weight.regular,
                margin: '0 auto',
                maxWidth: 375
            }),
            xs: _objectSpread({}, readingDirection, {
                fontSize: font.base.size.h3,
                display: 'block',
                textAlign: 'center',
                color: font.color.base,
                fontFamily: font.base.family,
                fontWeight: font.base.weight.regular,
                margin: '0 auto',
                maxWidth: 375
            })
        },
        body: {
            default: _objectSpread({}, readingDirection, {
                fontSize: font.base.size.m,
                color: font.color.soft,
                display: 'block',
                textAlign: 'center',
                fontFamily: font.base.family,
                fontWeight: font.base.weight.regular,
                margin: '0 auto',
                maxWidth: 375
            }),
            xs: {
                readingDirection: readingDirection,
                fontSize: font.base.size.s,
                color: font.color.soft,
                display: 'block',
                textAlign: 'center',
                fontFamily: font.base.family,
                fontWeight: font.base.weight.regular,
                margin: '0 auto',
                maxWidth: '100%'
            }
        },
        error: _objectSpread({}, readingDirection, {
            color: font.color.danger.base,
            fontSize: font.base.size.s,
            textAlign: 'center',
            fontFamily: font.base.family,
            margin: '0 auto'
        }),
        errorDetails: _objectSpread({}, readingDirection, {
            fontSize: font.base.size.xs,
            color: font.color.soft,
            fontFamily: font.base.family,
            textAlign: 'center',
            fontWeight: font.base.weight.regular,
            lineHeight: font.lineHeight.heading
        })
    };
};
var useStyle = function(isRtl) {
    var ref;
    var ref1 = (ref = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref !== void 0 ? ref : {
        container: {},
        actionContainer: {},
        wrapper: {},
        image: {},
        illustrationContainer: {},
        header: {
            default: {},
            xs: {}
        },
        body: {
            default: {},
            xs: {}
        },
        error: {},
        errorDetails: {}
    }, container = ref1.container, actionContainer = ref1.actionContainer, wrapper = ref1.wrapper, image = ref1.image, illustrationContainer = ref1.illustrationContainer, header = ref1.header, body = ref1.body, error = ref1.error, errorDetails = ref1.errorDetails;
    return {
        containerStyles: container,
        actionContainerStyles: actionContainer,
        wrapperStyles: wrapper,
        imageStyles: image,
        illustrationContainerStyles: illustrationContainer,
        headerDefaultStyles: header.default,
        headerSmallStyles: header.xs,
        bodyDefaultStyles: body.default,
        bodySmallStyles: body.xs,
        errorStyles: error,
        errorDetailStyles: errorDetails
    };
};
export default useStyle;
